const messages = {
  back: 'cambiar fecha y hora',
  buttonText: 'CONFIRMAR CITA',
  error: 'Hubo un error al crear la cita, intente más tarde',
  welcome: '{Name}, la sonrisa de tus sueños esta cerca',
}

export default messages
